// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner_banner__2mb7y","icon":"Banner_icon__2sgVw","warning":"Banner_warning__3Y8s9","info":"Banner_info__2MycA"};